export enum DeskStatus {
  FREE = "free",
  DEDICATED = "dedicated",
  DISABLED = "disabled",
}
